import { Component, inject, OnInit, Signal } from '@angular/core';
import { BreadcrumbsComponent } from '../../../common/breadcrumbs/breadcrumbs.component';
import { ContentComponent } from '../../../components/content/content.component';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ShipmentAppEntityShipmentItemRead, ShipmentAttachmentAppEntityShipmentItemRead } from '../../../openapi';
import { Store } from '@ngrx/store';
import { loadShipmentItem } from '../../../store/actions/my-cases.actions';
import { selectLoading, selectShipment } from '../../../store/selectors/my-cases.selectors';
import { SpinnerComponent } from '../../../common/spinner/spinner.component';
import { DatePipe } from '@angular/common';
import { LabelComponent } from '../../../common/label/label.component';
import { UploaderAttachmentsService } from '../../../services/uploader-attachments.service';

@Component({
  selector: 'app-my-case-shipment-details-page',
  standalone: true,
  imports: [
    BreadcrumbsComponent,
    ContentComponent,
    RouterLink,
    SpinnerComponent,
    DatePipe,
    LabelComponent
  ],
  providers: [UploaderAttachmentsService],
  templateUrl: './my-case-shipment-details-page.component.html'
})
export class MyCaseShipmentDetailsPageComponent implements OnInit {

  private route: ActivatedRoute = inject(ActivatedRoute);

  private store$: Store = inject(Store);

  public shipment: Signal<ShipmentAppEntityShipmentItemRead | null> = this.store$.selectSignal(selectShipment);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  private uploaderService: UploaderAttachmentsService = inject(UploaderAttachmentsService);

  public onDownloadAttachment(event: Event, v: ShipmentAttachmentAppEntityShipmentItemRead): void {
    event.preventDefault();
    event.preventDefault();
    this.uploaderService.downloadAttachment(v.attachment?.id || '', v.attachment?.customName || v?.attachment?.originalName || '')
      .subscribe();
  }

  public ngOnInit(): void {
    this.store$.dispatch(loadShipmentItem({ id: this.route.snapshot.params['shipmentId'] }));
  }
}
